import { createSelector } from 'reselect';

const selectAdminLevelOne = (state: any) => state.AdminLevelOne;


export const selectAdminLevelOneCurrentItem = createSelector([selectAdminLevelOne], (AdminLevelOne) => AdminLevelOne.current);

export const selectAdminLevelOneListItems = createSelector([selectAdminLevelOne], (AdminLevelOne) => AdminLevelOne.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectAdminLevelOneListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectAdminLevelOneQueryItems = createSelector([selectAdminLevelOne], (AdminLevelOne) => AdminLevelOne.query);

export const selectAdminLevelOneCreatedItem = createSelector([selectAdminLevelOne], (AdminLevelOne) => AdminLevelOne.create);

export const selectAdminLevelOneUpdatedItem = createSelector([selectAdminLevelOne], (AdminLevelOne) => AdminLevelOne.update);

export const selectAdminLevelOneReadItem = createSelector([selectAdminLevelOne], (AdminLevelOne) => AdminLevelOne.read);

export const selectAdminLevelOneDeletedItem = createSelector([selectAdminLevelOne], (AdminLevelOne) => AdminLevelOne.delete);

export const selectAdminLevelOneSearchedItems = createSelector([selectAdminLevelOne], (AdminLevelOne) => AdminLevelOne.search);

export const selectAdminLevelOneItemsCount = createSelector([selectAdminLevelOne], (AdminLevelOne) => AdminLevelOne.count);

export const selectAdminLevelOneItemsFilter = createSelector([selectAdminLevelOne], (AdminLevelOne) => AdminLevelOne.filter);